// Промежуточный экран — подтверждение выхода (вызывается из MeScreen → /logout-confirm).
// После подтверждения — userManager.signoutRedirect() → Keycloak → возврат на /logout.
import { useState } from 'react'
import { AuthScreen, Button, Card } from '@dss/design-system'
import { useAuth } from '@dss/auth'
import { Link } from '../../lib/router'
import { useDistributorBrand } from '../../lib/distributor-brand'

export function LogoutConfirmScreen() {
  const { logout } = useAuth()
  const { current: brand } = useDistributorBrand()
  const [busy, setBusy] = useState(false)

  return (
    <AuthScreen brand={brand ?? undefined}>
      <Card padding="lg">
        <h1
          style={{
            margin: '0 0 8px',
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: '-0.01em',
          }}
        >
          Выход
        </h1>
        <p
          style={{
            margin: '0 0 20px',
            fontSize: 14,
            color: 'var(--color-text-secondary)',
            lineHeight: 1.5,
          }}
        >
          Вы уверены, что хотите выйти? Несохранённые черновики заказов могут быть потеряны.
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link to="/me" style={{ flex: 1, textDecoration: 'none' }}>
            <Button variant="secondary" fullWidth>
              Отмена
            </Button>
          </Link>
          <Button
            variant="danger"
            fullWidth
            loading={busy}
            onClick={async () => {
              setBusy(true)
              try {
                await logout()
              } catch {
                setBusy(false)
              }
            }}
            style={{ flex: 1 }}
          >
            Выйти
          </Button>
        </div>
      </Card>
    </AuthScreen>
  )
}
